<mat-card class="cardWithShadow">
    <mat-card-content>
    <mat-card-title>Minutas</mat-card-title>
  
      <div class="spinner">
        <mat-spinner [diameter]="60" *ngIf="booleanFlag == true"></mat-spinner>
        <h3 *ngIf="booleanText == false">No existen Minutas</h3>
      </div>
      
      <div class="table-responsive m-t-30" [class.esconder]="booleanFlag == true" >
        <table mat-table [dataSource]="dataSource" class="w-100" matSort
        (matSortChange)="changeSortingTable($event)">
  
          <ng-container matColumnDef="MinuteRequestId">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
              Codigo
            </th>
            <td mat-cell *matCellDef="let element" (click)="redirectMinute(element.minuteRequestId)"
            style="text-align: center; text-decoration: underline; color: blue; cursor: pointer">
              <h6>
                {{ element.minuteRequestId }}
              </h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="CompanyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
              Compañia/Cliente
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
              <h6>
                {{ element.company.companyName }}
              </h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="factoringLine">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
              Linea Factoring
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
              <h6>
                {{ element.factoringLine  | currency : "CLP" : "symbol" }}
              </h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="warrantyLine">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
              Linea Garantia
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
              <h6>
                {{ element.warrantyLine  | currency : "CLP" : "symbol" }}
              </h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="MinuteState">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
              Estado
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
              <h4 [ngStyle]="setMinuteStyle(element.minuteState)">{{ element.minuteState }}</h4>
            </td>
          </ng-container>
          <ng-container matColumnDef="CreatedAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
              Fecha
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
              <h6>
                {{ element.createdAt | date : "medium" : "  -08:00"  }}
              </h6>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row class="cursor-table" *matRowDef="let row; columns: displayedColumns"></tr>
  
        </table>
        <mat-paginator (page)="changePaginationTable($event)" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  
      </div>
    </mat-card-content>
</mat-card>